<template>
  <div class="shoppingcar" :class="current_theme">
    <div class="shoppingcarbody container" v-show="show_car">
      <h2 class="title_font">{{$t('cart.your_cart')}}</h2>
      <v-line></v-line>
      <div v-if="!cartmes.cart_contents_count||error">
        <div v-if="error">
          <p>{{error}}</p>
        </div>
        <div v-else>
          <p>{{$t('cart.cart_empty')}}</p>
          <p>
            {{$t('cart.cart_browse')}}
            <a href="/collections/all">{{$t('cart.cart_here')}}</a>
          </p>
        </div>
      </div>
      <div class="shoppingcarbodylist col-md-10 offset-md-1 col-12" v-else>
        <div class="row shoppingcarbodylisthead">
          <div class="col-2 offset-7 secondary_title">{{$t('cart.quantity')}}</div>
          <div class="col-3 text-right secondary_title">{{$t('cart.total')}}</div>
        </div>
        <div v-for="item in cartmes.cart" :key="item.key" class="row shoppingcarbodylistitem">
          <div class="col-md-2 col-4">
            <a :href="item.product.path||item.product.public_url">
              <img
                :src="item.variant?item.variant.feature_image?item.variant.feature_image.thumbnail:item.product.feature_image?item.product.feature_image.thumbnail:defaultImage:item.product.feature_image?item.product.feature_image.thumbnail:defaultImage"
                @error.once="imageFailure"
                width="100%"
                class="lazyload"
              />
            </a>
          </div>
          <div class="col-md-5 col-8 text-left">
            <a :href="item.product.path||item.product.public_url">
              <p>{{item.product.post_title}}</p>
              <p class="variant" v-if="item.variant">
                <template v-for="(subitem,subindex) in item.variant.attrs">
                  <span
                    v-if="subitem.value!='Default Title'"
                    :key="subitem+subindex"
                  >{{subitem.value}}</span>
                </template>
              </p>
            </a>
            <a href="#" @click.stop.prevent="removeproduct(item.key)">{{$t('cart.remove')}}</a>
          </div>
          <div class="col-md-5 col-12 numprice">
            <div class="row">
              <div class="col-md-4 col-sm-8 total_sm">
                <!-- <input
                  type="number"
                  class="commoditynum"
                  v-model="item.quantity"
                  @keyup.enter="checkout_active = true&&changequantity(item.quantity,item.key)"
                  @change="changequantity(item.quantity,item.key)"
                  value="1"
                  min="1"
                />-->
                <el-input-number
                  v-model="item.quantity"
                  :min="0"
                  :max="100000"
                  :precision="0"
                  :step="1" step-strictly
                  :disabled="disabled_num"
                  @keyup.enter.native="checkout_active = true&&changequantity(item.quantity,item.key,item.product_id,item.variation_id)"
                  @change="changequantity(item.quantity,item.key,item.product_id,item.variation_id)"
                ></el-input-number>
              </div>
              <div class="col-md-8 text-md-right col-sm-8 selet_sm">
                <v-selectprice
                  v-if="item.line_subtotal-0>item.line_total-0"
                  :price="item.line_subtotal"
                  fontSize="13.5"
                  regular_price="regular_price"
                ></v-selectprice>
                <v-selectprice :price="item.line_total" fontSize="15"></v-selectprice>
              </div>
            </div>
          </div>
        </div>
        <div class="row shoppingcarbodylistfoot justify-content-md-end justify-content-center">
          <div class="subtotal">{{$t('cart.subtotal')}}</div>
          <div class="text-sm-center" style="margin-left:5px;padding-right:15px">
            <v-selectprice :price="complete_subtotal" fontSize="15"></v-selectprice>
          </div>
        </div>
        <div class="row" style="margin-top:15px" v-if="cartmes.discount_cart">
          <div class="col-12 text-center text-md-right" style="font-size:20px">
            {{$t('cart.saving')}}
            <v-selectprice :price="cartmes.discount_cart" fontSize="20"></v-selectprice>
          </div>
        </div>
        <div class="checkoutbox text-md-right text-center">
          <!-- <div class="col-md-5 col-12 offset-md-7 text-md-right text-center">
            <p style="margin:15px 0 0;">Tax included and shipping calculated at checkout</p>
          </div>-->
          <button
            class="checkout secondary_title main_button"
            :class="{'button_active':checkout_active}"
            :disabled="checkout_active"
            type="button"
            @click="checkouts"
          >{{$t('cart.check_out')}} →</button>
        </div>
        <div class="row" v-if="paypalposition=='cart'||paypalposition=='both'">
          <div class="col-md-5 offset-md-7">
            <div
              id="paypal-button"
              style="margin-top:15px;"
              :pixel="pixel"
              :cartmes="JSON.stringify(this.cartmes)"
            ></div>
            <!-- <v-paypal></v-paypal> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from "../../API.js";
import defaultImage from "../../../../public/images/no-image.gif";

export default {
  props: [
    "cart",
    "pixel",
    "paypalposition",
    "error",
    "pixel_conversion",
    "current_theme"
  ],
  data() {
    return {
      defaultImage,
      cartmes: "",
      checkout_active: false,
      show_car: true,
      disabled_num: false
    };
  },
  computed: {
    complete_subtotal() {
      let subtotal = this.cartmes.cart_total - this.cartmes.shipping_total;
      if (
        this.cartmes.fees &&
        this.cartmes.fees["shipping-insurance"] &&
        this.cartmes.fees["shipping-insurance"].amount
      ) {
        subtotal = subtotal - this.cartmes.fees["shipping-insurance"].amount;
      }
      return subtotal;
    }
  },
  methods: {
    imageFailure(e) {
      e.target.src = defaultImage;
    },
    async removeproduct(key) {
      try {
        var res = await this.$axios.delete(API.deletecart + key);
        this.cartmes = res.data;
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
      // this.$axios
      //   .delete(API.deletecart + key)
      //   .then(res => {
      //     if (res.status == 200) {
      //       console.log(res);

      //       this.cartmes = res.data;
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    async changequantity(quantity, key, product_id, variant_id) {
      this.disabled_num = true;
      if (this.checkout_active) return;
      console.log(quantity, key);
      if (quantity === "") {
        return;
      } else if (quantity > 0 && quantity < 1) {
        quantity = 1;
      } else if (quantity > 100000) {
        quantity = 100000;
      } else if (quantity >= 1) {
        quantity = Math.floor(quantity);
      } else if (quantity == 0) {
      } else {
        window.location.reload();
        return;
      }
      let product_argument = variant_id
        ? { quantity, product_id, variant_id }
        : { quantity, product_id };
      const _this = this;
      const CancelToken = this.$axios.CancelToken;
      this.cancelTokenFn && this.cancelTokenFn();
      this.cancelTokenFn = null;
      try {
        var res = await this.$axios.put(
          API.changequantity + key,
          product_argument,
          {
            cancelToken: new CancelToken(function executor(c) {
              _this.cancelTokenFn = c;
            })
          }
        );
        this.disabled_num = false;
        this.cartmes = res.data;
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
      } catch (error) {
        this.disabled_num = false;
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.$message.error(error.response.data.message);
        }
        this.checkout_active = false;
      }
    },
    checkouts() {
      this.checkout_active = true;
      let cart_hash = this.getCookie("cart_hash");
      if (window.fbq) {
        let cart_item = Object.values(this.cartmes.cart);
        let content_ids = [];
        let product_category_ids = [];
        cart_item.forEach(item => {
          content_ids.push(item.product_id);
          if (item.category_ids) {
            product_category_ids = product_category_ids.concat(
              item.category_ids
            );
          }
        });
        if (
          this.pixel_conversion &&
          this.pixel_conversion.pixel_conversion &&
          this.pixel_conversion.pixel_conversion.length &&
          product_category_ids.length
        ) {
          this.initFBevent(
            this.pixel_conversion.pixel_conversion,
            product_category_ids
          );
        }
        console.log("content_ids", content_ids);
        window.fbq("track", "InitiateCheckout", {
          content_type: "product_group",
          content_ids,
          value: this.cartmes.cart_total,
          num_items: this.cartmes.cart_contents_count,
          currency: this.cartmes.currency ? this.cartmes.currency : "USD"
        });
      }
      this.$axios.post(API.statis_event, {
        name: "cart.check",
        parameters: { url: window.location.href }
      });
      if (window.gtag) {
        window.gtag("event", "cart.check", {
          event_category: "ecommerce"
        });
      }
      setTimeout(() => {
        this.checkout_active = false;
      }, 5000);
      this.toCheckInfo(cart_hash);
      // window.open(`/checkouts/${cart_hash}`, "_self");
    }
  },
  async beforeMount() {
    console.log(this.current_theme);
    if (
      !window.fbq &&
      this.pixel_conversion &&
      this.pixel_conversion.pixel_conversion
    ) {
      this.FBevent();
    }
    this.cartmes = this.cart;
    this.$store.dispatch("cartContentsCount", this.cartmes.cart_contents_count);
    localStorage.setItem("cartContentsCount", this.cartmes.cart_contents_count);
    // window.addEventListener("popstate", e => {
    // this.checkout_active = false;
    // });
    console.log(this.cartmes);
    console.log("error", this.error);
    if (window.performance.navigation.type == 2) {
      try {
        this.show_car = false;
        let res = await this.$axios.get(API.addcart + "?" + Math.random());
        this.cartmes = res.data;
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        this.show_car = true;
      } catch (error) {
        this.show_car = true;
        this.$message.error(error.response.data.message);
      }
    }
  },
  watch: {
    "$store.state.news_cart"() {
      console.log("cart  store.state.news_cart", this.$store.state.news_cart);
      this.cartmes = this.$store.state.news_cart;
    }
  }
};
</script>
<style  lang='scss'>
.shoppingcar {
  margin-top: 80px;
  margin-bottom: 40px;
  position: relative;
  .shoppingcarbody {
    text-align: center;

    h2 {
      font-size: 26px;
      color: #222323;
    }

    .shoppingcarbodylist {
      margin-top: 50px;
      .shoppingcarbodylisthead {
        border-bottom: 1px solid black;
        padding-bottom: 10px;
        margin-bottom: 30px;
      }

      .shoppingcarbodylistitem {
        margin-bottom: 30px;
        align-items: center;

        // .commoditynum {
        //   width: 100%;
        //   height: 26px;
        //   box-sizing: border-box;
        //   padding: 8px 10px;
        //   box-sizing: content-box;
        //   border: none;
        //   background-color: #f6f6f6;
        //   text-align: center;
        // }
        .numprice {
          .el-input-number {
            width: 100px !important;
            .el-input-number__decrease,
            .el-input-number__increase {
              width: 29px !important;
              background: unset !important;
              i {
                font-weight: 600 !important;
              }
              &:hover {
                background-color: #e9e9e9 !important;
                color: #1c1d1d !important;
              }
            }
            .el-input {
              .el-input__inner {
                font-size: 18px;
                background-color: #f6f6f6 !important ;
                padding: 5px 25px !important;
                border: 0px solid #dcdfe6 !important;
              }
            }
          }
          .is-disabled {
            .el-input-number__decrease,
            .el-input-number__increase {
              &:hover {
                background-color: unset !important;
                color: #e4e7ed !important;
              }
            }
          }
        }

        & > div:nth-child(2) {
          color: black;
          a {
            text-decoration: none;
            color: black;
            p {
              font-size: 16px;
              margin-bottom: 5px;
              color: black;
            }
            .variant {
              font-size: 12px;
              color: #717171;
              & > span:not(:last-child)::after {
                content: " / ";
              }
            }
          }
        }
      }

      .shoppingcarbodylistfoot {
        border-top: 1px solid black;
        padding-top: 10px;
        .currency-tips {
          color: rgba(0, 0, 0, 0.65);
          border: 1px solid #ffe58f;
          background-color: #fffbe6;
          padding: 8px 12px;
          margin-bottom: 12px;
        }

        .subtotal {
          font-weight: 600;
          font-style: normal;
          letter-spacing: 0.1em;
          text-transform: uppercase;
        }
      }
      .checkoutbox {
        text-align: right;
        .checkout {
          display: inline-block;
          padding: 12px 20px;
          border: none;
          background: rgb(201, 13, 13) !important;
          color: white;
          font-weight: 600;
          font-style: normal;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          font-size: 14px;
          margin-top: 15px;
          border-radius: 0;
          cursor: pointer;
          &:hover {
            background: rgb(241, 34, 34) !important;
          }
        }
        
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .shoppingcar {
    margin-top: 30px !important;
    margin-bottom: -10px !important;
    .shoppingcarbody {
      .shoppingcarbodylist {
        margin-top: 10px !important;
      }
    }
  }
  .shoppingcarbodylisthead {
    display: none;
  }

  .shoppingcarbodylistfoot {
    margin: 0;
  }

  .shoppingcarbodylistitem {
    align-items: stretch !important;
  }

  .numprice {
    padding-top: 8px !important;
  }
  .total_sm {
    text-align: left;
    margin-left: 33.3%;
    order: 13;
  }
  .selet_sm {
    text-align: left;
    margin-left: 33.3%;
    order: -1;
    margin-bottom: 20px;
  }
  .venue {
    margin-bottom: 20px !important;
  }
}
</style>